import { getTranslate } from 'legacy-src/utilities/i18n'
import Link from 'next/link'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import useIsAppWebView from '../../hooks/useIsAppWebView'
import useTherapistData from '../../hooks/useOwnTherapistData'
import Loader from '../Loader'
import useInsuranceCompanies from './hooks/useInsuranceCompanies'
import { type InsuranceCompany } from './types'

type Props = {
  readonly therapistId: number
}

const Company: React.FC<{ company: any }> = ({ company }) => (
  <div className="mb-4 mr-3 flex items-center rounded-xl bg-white p-2 px-4">
    {company?.logo && <img className="mr-3" style={{ height: 20 }} src={company.logo} alt={company.name} />}
    <div className="font-bold text-text-color">{company?.name}</div>
  </div>
)

const InsuranceCompanyList: React.FC<Props> = ({ therapistId }) => {
  const { t } = getTranslate()
  const isWebView = useIsAppWebView()
  const { insuranceCompanies, isLoading } = useInsuranceCompanies()
  const { therapistData, isLoading: isLoadingTherapist } = useTherapistData(therapistId)

  const { insurances } = therapistData || {}
  const insuranceIds = insurances
  const relevantCompanies = insuranceCompanies?.filter((company: InsuranceCompany) => {
    return insuranceIds?.includes(company.id) || company.defaultOn
  })

  if (isLoading || isLoadingTherapist) return <Loader visible loaderType="section-large" />

  if (!relevantCompanies) return null

  return (
    <div>
      {relevantCompanies.length > 0 && (
        <>
          <h3>{t('component.insuranceCompanyList.headline')}</h3>
          <div className={cn('mb-8 flex flex-wrap font-bold text-text-color')}>
            {relevantCompanies.map((company, key) =>
              isWebView ? (
                <Company company={company} key={key} />
              ) : (
                <Link key={key} href={company.url || ''} target="_blank">
                  <Company company={company} />
                </Link>
              ),
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default InsuranceCompanyList
